<template>
    <ModalBase
        name="pagar-todos-plazos-modal"
        title="Seleccionar Método de Pago"
        @close="handleClose"
    >
        <div class="tw:space-y-4">
            <p class="tw:text-sm tw:text-gray-700">
                Selecciona el método de pago para proceder
            </p>

            <div class="tw:bg-blue-50 tw:border tw:border-blue-200 tw:rounded-lg tw:p-4 tw:space-y-2">
                <div class="tw:flex tw:justify-between">
                    <span class="tw:text-sm tw:font-medium tw:text-gray-700">Cantidad de plazos:</span>
                    <span class="tw:text-sm tw:text-gray-900 tw:font-semibold">{{ plazosCount }}</span>
                </div>
                <div class="tw:flex tw:justify-between">
                    <span class="tw:text-sm tw:font-medium tw:text-gray-700">Total importe:</span>
                    <span class="tw:text-sm tw:text-gray-900 tw:font-semibold">{{ importe | formatear_precio }}</span>
                </div>
            </div>

            <div>
                <label class="tw:block tw:text-sm tw:font-medium tw:text-gray-700 tw:mb-2">
                    Método de pago
                </label>
                <BaseMultiselect 
                    v-model="selectedMethod" 
                    :options="metodosPago" 
                    labelKey="nombre" 
                    valueKey="id" 
                    placeholder="-- Selecciona un método --"
                />
            </div>
        </div>

        <template #footer>
            <div class="tw:flex tw:gap-2 tw:justify-end">
                <Button variant="border" @click="handleClose">
                    Cancelar
                </Button>
                <Button 
                    variant="primary" 
                    :disabled="!selectedMethod"
                    @click="handleConfirm"
                >
                    Pagar
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref, getCurrentInstance } from 'vue'
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue'
    import { usePagoMethods } from '@/composables/admin/abonados/usePagoMethods'

    const props = defineProps({
        importe: {
            type: Number,
            required: true
        },
        plazosCount: {
            type: Number,
            required: true
        }
    })

    const emit = defineEmits(['pagar-todos', 'close'])

    const instance = getCurrentInstance()
    const { metodosPago } = usePagoMethods()
    const selectedMethod = ref('')

    const handleConfirm = () => {
        if (selectedMethod.value) {
            emit('pagar-todos', {
                metodoId: selectedMethod.value
            })
            handleClose()
        }
    }

    const handleClose = () => {
        selectedMethod.value = ''
        instance.proxy.$modal.hide('pagar-todos-plazos-modal')
        emit('close')
    }
</script>
